module.exports = __webpack_public_path__ + "img/vaccine-schedule.5a6399e1.svg";